import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/global/generic.types.js').Link>} */
const initialState = [];

/**
 * @param {Array<import('modules/global/generic.types.js').Link>} _
 * @param {import('modules/statistics/types').FetchTopContributorsStatsSuccessAction} action
 * @returns {Array<import('modules/global/generic.types.js').Link>}
 */
const updateAllLinks = (_, { payload }) => payload.links;

export default createReducer(initialState, {
  [types.FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_SUCCESS]: updateAllLinks,
});
